import { withPortalBoxFeatures } from '@/features/shared/HOCs/withPortalBoxFeatures';
import React from 'react';

import { NEWS_RIBBON_BOX_PORTAL_ID, NEWS_RIBBON_BOX_PORTAL_EVENT } from './NewsRibbon.constants';

const PortalNavigationBox = withPortalBoxFeatures((props) => <div {...props} />, {
  boxId: NEWS_RIBBON_BOX_PORTAL_ID,
  readyEventName: NEWS_RIBBON_BOX_PORTAL_EVENT,
});

export default PortalNavigationBox;
